import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { LifecycleRetireIntent } from 'Deer/intent/Lifecycle/LifecycleRetireIntent';
import { LifecycleInsightsDropdown } from 'Deer/intent/Lifecycle/components/LifecycleInsightsDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import { IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

export type LifecycleInsightsIntentType = {
  label: string;
  onClick: () => void;
  visible: () => boolean;
  value: {
    company?: IntentValuesType;
  };
  category: 'Retire';
};

const LifecycleRetire = () => {
  const { moduleName } = useOrganisationSettings();

  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  return (
    <Layout
      Filters={
        <LifecycleInsightsDropdown
          breadcrumbs={{
            items: [
              {
                label: 'Company',
                to: applicableL2CompanyModules[0]?.value,
              },
            ],
            page: {
              label: 'Lifecycle insights',
              to: '',
            },
          }}
        />
      }
    >
      <LifecycleRetireIntent />
    </Layout>
  );
};

export { LifecycleRetire };
